export default {
    lifePerVitality: {
        "Amazon": 3,
        "Sorceress": 2,
        "Necromancer": 2,
        "Paladin": 3,
        "Barbarian": 4,
        "Druid": 2,
        "Assassin": 3
    },
    manaPerEnergy: {
        "Amazon": 1.5,
        "Sorceress": 2,
        "Necromancer": 2,
        "Paladin": 1.5,
        "Barbarian": 1,
        "Druid": 2,
        "Assassin": 1.75
    },
    calculate: function(attributes, list) {

        for(var i = 0; i < list.length; i++) {

            switch(list[i].id) {
                // all res.
                case -1:
                    attributes.fire_res += list[i].value;
                    attributes.cold_res += list[i].value;
                    attributes.light_res += list[i].value;
                    attributes.poison_res += list[i].value;
                    break;

                // Strength.
                case 0:
                case 220:
                    attributes.strength += list[i].value;
                    break;

                // Energy.
                case 1:
                case 222:
                    attributes.energy += list[i].value;
                    break;

                // Dexterity.
                case 2:
                case 221:
                    attributes.dexterity += list[i].value;
                    break;

                // Vitality.
                case 3:
                case 223:
                    attributes.vitality += list[i].value;
                    break;

                // Max HP.
                case 7:
                case 216:
                    attributes.max_hp += list[i].value;
                    break;

                // Max mana.
                case 9:
                case 217:
                    attributes.max_mana += list[i].value;
                    break;

                // Max percentage HP.
                case 76:
                    attributes.max_percent_hp += list[i].value;
                    break;

                // Max percentage mana.
                case 77:
                    attributes.max_percent_mana += list[i].value;
                    break;

                // Fire res.
                case 39:
                case 231:
                    attributes.fire_res += list[i].value;
                    break;

                // Cold res.
                case 43:
                case 230:
                    attributes.cold_res += list[i].value;
                    break;

                // Lightning res.
                case 41:
                case 232:
                    attributes.light_res += list[i].value;
                    break;

                // Poison res.
                case 45:
                case 233:
                    attributes.poison_res += list[i].value;
                    break;

                // Maximum fire res.
                case 40:
                    attributes.max_fire_res += list[i].value;
                    break;

                // Maximum cold res.
                case 44:
                    attributes.max_cold_res += list[i].value;
                    break;

                // Maximum lightning res.
                case 42:
                    attributes.max_light_res += list[i].value;
                    break;

                // Maximum poison res.
                case 46:
                    attributes.max_poison_res += list[i].value;
                    break;

                default:
                    break;
            }
        }

        return attributes;
    },
    calculateItem: function(item, extraAttributes) {

        if (item.magic_attributes !== undefined) {
            this.calculate(extraAttributes, item.magic_attributes);
        }

        // if(item.runeword_attributes !== null) {
        //     this.calculate(extraAttributes, item.runeword_attributes);
        // }

        // if(item.socketed_items !== null) {
        //     for(var i = 0; i < item.socketed_items.length; i++) {
        //         this.calculate(extraAttributes, item.socketed_items[i].magic_attributes);
        //     }
        // }
    }
};



// WEBPACK FOOTER //
// ./src/lib/attributes-calculator.js